module.exports = __webpack_public_path__ + "img/ad.b4e3ad87.svg";